import moment from 'moment/moment';

/**
 * Returns class to display in the cell of the calendar
 * @param cellDate
 * @param inputDate
 * @param classes
 *  unselectedClass: string,  // Default: 'unselected'. Class used when the date is not selected
 *  fromClass: string, // Default: 'from' Class used when the date is the start of the interval
 *  toClass: string, // Default: 'to'. Class used when the date is the end of the interval
 *  intervalClass: string, // Default: 'interval'. Class used when the date is between the start and end of the interval
 */

export function customCalendarCellClass(
  cellDate: any,
  dateOfJob: any,
  classes?: {
    unselectedClass?: string;
    fromClass?: string;
    toClass?: string;
    intervalClass?: string;
    sameDateClass?: string;
    beforeTodayClass?: string;
  },
) {
  if (classes == null) {
    classes = {};
  }

  classes.unselectedClass = classes.unselectedClass ?? 'unselected';
  classes.fromClass = classes.fromClass ?? 'from';
  classes.toClass = classes.toClass ?? 'to';
  classes.intervalClass = classes.intervalClass ?? 'interval';
  classes.sameDateClass = classes.sameDateClass ?? 'same-date';
  classes.beforeTodayClass = classes.beforeTodayClass ?? 'before-today';

  let fromDate = '';
  let toDate = '';
  let displayDate = moment(cellDate.year + '-' + (cellDate.month + 1) + '-' + cellDate.day).format(
    'YYYY-MM-DD',
  );

  if (dateOfJob?.length > 0 && dateOfJob[0] != null) {
    fromDate = moment(dateOfJob[0]).format('YYYY-MM-DD');
    if (dateOfJob?.length > 1 && dateOfJob[1] != null) {
      toDate = moment(dateOfJob[1]).format('YYYY-MM-DD');
    }
  }

  if (displayDate == fromDate || displayDate == toDate) {
    if (displayDate == fromDate && displayDate == toDate) {
      return classes.sameDateClass;
    } else if (displayDate == fromDate) {
      return classes.fromClass;
    } else {
      return classes.toClass;
    }
  }

  if (displayDate >= fromDate && displayDate <= toDate) {
    return classes.intervalClass;
  }

  if (displayDate < moment().format('YYYY-MM-DD')) {
    return classes.beforeTodayClass;
  }

  return classes.unselectedClass;
}
